



















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class LLA extends Vue {
  @Prop() setLla: string;
  @Prop() setLabel!: string;
  label = "";
  placeholder = this.setLabel;
  msg = "";
  validasi = [(v) => this.cek(v) || this.message()];

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setLla == "" || this.setLla == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }
  @Watch("setLla")
  changeAlergi(v) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (v == "" || v == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("lla", v);
    // console.log(v);
    this.setLla = v;
  }
  titik() {
    if (this.setLla) {
      this.setLla = this.setLla.split(",").join(".");
    }
  }
  cek(v) {
    if (this.setLla != null) {
      if (
        this.setLla.substring(this.setLla.length - 1, this.setLla.length) == ","
      ) {
        this.titik();
      } else if (isNaN(Number(this.setLla)))
        this.setLla = this.setLla.substring(0, this.setLla.length - 1);
      if (this.setLla.length > 3)
        this.setLla = this.setLla.substring(0, this.setLla.length - 1);
    }
    if (Number(v) > 200) {
      this.msg = "*LLA " + v + " cm, Anda yakin?";
      return false;
    } else return true;
  }
  message() {
    return this.msg;
  }
}
